import { motion } from "framer-motion";

const stats = [
  { big: "12×", label: "Blackmagic cameras, colour-matched & broadcast-ready" },
  { big: "6", label: "Crew on-site — camera ops, vision mixer, stream tech, sound & show runner" },
  { big: "2", label: "Internet paths — wired ethernet + EE 5G failover. Your stream stays live" },
  { big: "1", label: "Point of contact from first cue to final credit" },
];

const caps = ["Vision Mixing", "Teams · Zoom · YouTube · Webinar", "Hybrid Events", "PA & Comms", "Room Dressing", "Confidence Monitors", "PIP Overlays", "Acoustic Treatment"];

export const Broadcast = () => (
  <section id="live" className="py-24 sm:py-32 bg-[#0A0A0A] text-white overflow-hidden" data-testid="broadcast-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 flex flex-wrap items-end justify-between gap-8"
      >
        <div>
          <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">Live & Hybrid</p>
          <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none max-w-2xl">
            Broadcast-quality. <span className="text-outline-white font-display uppercase">Rock-solid.</span>
          </h2>
        </div>
        <p className="max-w-md text-white/70 text-lg leading-relaxed">
          High-quality, reliable live production and hybrid broadcasting across the UK. Deep technical expertise, creative production mindset — polished on-site and broadcast-ready online.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-lg overflow-hidden mb-16">
        {stats.map((s, i) => (
          <motion.div
            key={s.big + i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="bg-[#0A0A0A] p-8 hover:bg-[#141414] transition-colors duration-300"
            data-testid={`broadcast-stat-${i + 1}`}
          >
            <span className="font-display text-6xl sm:text-7xl text-[#E80042] block mb-4">{s.big}</span>
            <p className="text-white/70 text-base leading-relaxed">{s.label}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="flex flex-wrap gap-3"
      >
        {caps.map((c) => (
          <span key={c} className="border border-white/25 rounded-full px-5 py-2.5 text-sm uppercase tracking-[0.15em] hover:bg-[#E80042] hover:border-[#E80042] transition-colors duration-300 cursor-default">
            {c}
          </span>
        ))}
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mt-14 text-white/50 text-sm uppercase tracking-[0.2em]"
      >
        Delivered for — BBC · Deliveroo · West Ham United · LinkedIn · BT · Amazon Prime Video · AMEX · EE · GOV.UK · Majestic Wines · University of Essex · Barking & Dagenham
      </motion.p>
    </div>
  </section>
);
